import {Component, Input} from "@angular/core";
import {Employee} from "../../../../../../../../../server/src/base/entities/employee/Employee";

@Component({
    selector: "employee",
    styleUrls: ['./employee.scss'],
    templateUrl: './employee.html'
})
export class EmployeeComponent {
    @Input() employee:Employee;
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/main/presentation/employee/employee.ts